import { render, staticRenderFns } from "./contractTerminationDetail.vue?vue&type=template&id=58e089f3&scoped=true"
import script from "./contractTerminationDetail.vue?vue&type=script&lang=js"
export * from "./contractTerminationDetail.vue?vue&type=script&lang=js"
import style0 from "./contractTerminationDetail.vue?vue&type=style&index=0&id=58e089f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e089f3",
  null
  
)

export default component.exports